import { render, staticRenderFns } from "./EmployeeViewNovi.vue?vue&type=template&id=1f43ae72&scoped=true"
import script from "./EmployeeViewNovi.vue?vue&type=script&lang=js"
export * from "./EmployeeViewNovi.vue?vue&type=script&lang=js"
import style0 from "./EmployeeViewNovi.vue?vue&type=style&index=0&id=1f43ae72&prod&scoped=true&lang=css"
import style1 from "./EmployeeViewNovi.vue?vue&type=style&index=1&id=1f43ae72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43ae72",
  null
  
)

export default component.exports